import { siteMap } from "internal-sitemap";
import { RouteTab } from "molecules/route-tabs/route-tabs";
import useFeatureFlags from "utilities/hooks/use-feature-flags";
import { t } from "utilities/localization-utils";

const useMyLiNKTabs = () => {
    const { useMyLiNKRedesign } = useFeatureFlags();

    const tabs: RouteTab[] = useMyLiNKRedesign
        ? [
              {
                  route: siteMap.myLink.myBookmarks.dashboard,
                  label: t("mylinkLayout-tabs-label-bookmarksAndCollections"),
              },
          ]
        : [
              {
                  route: siteMap.myLink.myBookmarks.dashboard,
                  label: t("mylinkLayout-tabs-label-myBookmarks"),
              },
              {
                  route: siteMap.myLink.collections,
                  label: t("collection_plural"),
              },
          ];

    return {
        tabs,
    };
};

export default useMyLiNKTabs;
